export default "__VITE_ASSET__071a87ee__"